import React, { useState, useRef, useEffect } from 'react';
import { Phone, Shield, CheckCircle, AlertCircle, User, FileText, RefreshCcw, ArrowRight, ArrowLeft, Clock, Key } from 'lucide-react';
import {VALIDATE_AADHAAR,VERIFY_AADHAAR,GET_AADHAAR_USER_DETAILS} from '../../constants.js';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const AadhaarEKYCComponent = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    mobileNumber: '',
    aadhaarNumber: '',
    firmName: '',
    otp: '',
    consent: false,
    // Data populated after successful OTP verification
    name: '',
    fatherName: '',
    dateOfBirth: '',
    gender: '',
    address: '',
    pincode: '',
    photo: null
  });
  const [errors, setErrors] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [kycCompleted, setKycCompleted] = useState(false);

  const steps = [
    // { title: 'Mobile Verification', icon: Phone },
    { title: 'eKYC Status', icon: Phone },
    { title: 'Aadhaar Details', icon: Shield },
    { title: 'OTP Verification', icon: Key },
    { title: 'KYC Complete', icon: CheckCircle }
  ];
     const navigate = useNavigate();
  

  // OTP Timer Effect
  useEffect(() => {
    let interval = null;
    if (otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer(timer => {
          if (timer === 1) {
            setCanResendOtp(true);
          }
          return timer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpTimer]);

  const validateStep = (step) => {
    const newErrors = {};
    
    switch (step) {
      case 0:
        if (!formData.aadhaarNumber.trim()) {
          newErrors.aadhaarNumber = 'Aadhaar number is required';
        } else if (!/^[6-9]\d{9}$/.test(formData.aadhaarNumber)) {
          newErrors.aadhaarNumber = 'Please enter a valid 12-digit aadhaar number';
        }
        break;
      case 1:
        // if (!formData.aadhaarNumber.trim()) {
        //   newErrors.aadhaarNumber = 'Aadhaar number is required';
        // } else if (!/^\d{12}$/.test(formData.aadhaarNumber.replace(/\s/g, ''))) {
        //   newErrors.aadhaarNumber = 'Please enter a valid 12-digit Aadhaar number';
        // }
        // if (!formData.consent) {
        //   newErrors.consent = 'Please provide consent to proceed';
        // }
        // break;
          if (!formData.otp.trim()) {
          newErrors.otp = 'OTP is required';
        } else if (!/^\d{6}$/.test(formData.otp)) {
          newErrors.otp = 'Please enter a valid 6-digit OTP';
        }
        break;
      case 2:
        if (!formData.otp.trim()) {
          newErrors.otp = 'OTP is required';
        } else if (!/^\d{6}$/.test(formData.otp)) {
          newErrors.otp = 'Please enter a valid 6-digit OTP';
        }
        break;
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    let processedValue = value;
    
    // Format Aadhaar number with spaces
    if (field === 'aadhaarNumber') {
      processedValue = value.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ').substr(0, 14);
    }
    
    // Format mobile number
    if (field === 'mobileNumber') {
      processedValue = value.replace(/\D/g, '').substr(0, 10);
    }
    
    // Format OTP
    if (field === 'otp') {
      processedValue = value.replace(/\D/g, '').substr(0, 6);
    }

    if (field === 'firmName') {
    processedValue = value.trimStart(); // allow normal typing but no leading spaces
  }
    
    setFormData(prev => ({ ...prev, [field]: processedValue }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // const sendOTP = async () => {
  //   // if (!validateStep(1)) return;
    
  //   setIsProcessing(true);
  //   alert("working----->")    
  //   try {
  //     // Simulate API call to UIDAI for OTP generation
  //     await new Promise(resolve => setTimeout(resolve, 2000));
      
  //     setOtpSent(true);
  //     setOtpTimer(120); // 2 minutes timer
  //     setCanResendOtp(false);
  //     setCurrentStep(2);
      
  //     // Show success message
  //     alert(`OTP sent to mobile number ending with ***${formData.mobileNumber.slice(-4)}`);
  //   } catch (error) {
  //     setErrors({ aadhaarNumber: 'Failed to send OTP. Please check your Aadhaar details.' });
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };

 const sendOTP = async () => {
  setIsProcessing(true);
const storedData = JSON.parse(localStorage.getItem("eKYCData"));



  try {
    const response = await fetch(VALIDATE_AADHAAR, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        lead_id: storedData.lead_id,
        firm_name: formData.firmName,
        mobile_number: formData.mobileNumber,
        aadhaar_number: formData.aadhaarNumber.replace(/\s/g, "")
      }),
    });

    const data = await response.json();
    console.log("VALIDATE_AADHAAR response:", data);

    if (response.ok && data.success) {
      localStorage.setItem("eKYCDataForVerify", JSON.stringify({
        request_id: data.data.request_id,
        aadhaar_user_id: data.data.aadhaar_user_id
      }));

      setOtpSent(true);
      setOtpTimer(120); // 2 minutes timer
      setCanResendOtp(false);
      setCurrentStep(2);
    } else {
      // setErrors(data.message || 'Failed to send OTP. Please try again.');
       toast.error(data.message || 'Failed to send OTP. Please try again.');
    }

  } catch (error) {
    console.error("Error sending OTP:", error);
    setErrors({ aadhaarNumber: 'Failed to send OTP. Please check your Aadhaar details.' });
  } finally {
    setIsProcessing(false);
  }
};

  const resendOTP = async () => {
    setIsProcessing(true);
const storedData = JSON.parse(localStorage.getItem("eKYCData"));


    
    try {
 const response = await fetch(VALIDATE_AADHAAR, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        lead_id: storedData.lead_id,
        firm_name: "new firm",
        mobile_number: storedData.mobile_number,
        aadhaar_number: formData.aadhaarNumber.replace(/\s/g, "")
      }),
    });

      const data = await response.json();
      
       if (response.ok && data.success) {
      localStorage.setItem("eKYCDataForVerify", JSON.stringify({
        request_id: data.data.request_id,
        aadhaar_user_id: data.data.aadhaar_user_id
      }));

      setOtpSent(true);
      setOtpTimer(120); // 2 minutes timer
      setCanResendOtp(false);
      setCurrentStep(2);
    } else {
      setErrors(data.message || 'Failed to send OTP. Please try again.');
    }
      // if (response.ok && data.success){
      //   setOtpSent(true);
      //   setOtpTimer(120);
      //   setCanResendOtp(false);
      //   setFormData(prev => ({ ...prev, otp: '' }));
      // }
      //   else {
      //   setErrors(data.message || 'Failed to send OTP. Please try again.');
      // }
    
    } catch (error) {
   setErrors({ aadhaarNumber: 'Failed to send OTP. Please check your Aadhaar details.' });
    } finally {
      setIsProcessing(false);
    }
  };

  const verifyOTP = async () => {
  setIsProcessing(true);

  try {
    const storedKYC = localStorage.getItem("eKYCDataForVerify");
    const parsedKYC = storedKYC ? JSON.parse(storedKYC) : null;

    const requestId = parsedKYC?.request_id;
    const aadhaarUserId = parsedKYC?.aadhaar_user_id;

    if (!requestId || !aadhaarUserId) {
      setErrors({ otp: "Missing Aadhaar verification data. Please request OTP again." });
      setIsProcessing(false);
      return;
    }

    const response = await fetch(VERIFY_AADHAAR, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request_id: requestId,
        otp: formData.otp,
        aadhaar_user_id: aadhaarUserId,
      }),
    });

    const data = await response.json();
    console.log("VERIFY_AADHAAR response:", data);

    if (response.ok && data.success) {
      const user = data.data; 
       
      // Combine address fields into one string
      const fullAddress = [
        user.address?.house,
        user.address?.street,
        user.address?.locality,
        user.address?.village_town_city,
        user.address?.subdistrict,
        user.address?.district,
        user.address?.state,
        user.address?.country
      ].filter(Boolean).join(", ");

      setFormData((prev) => ({
        ...prev,
        name: user.full_name || "",
        fatherName: user.care_of || "",
        dateOfBirth: user.dob || "",
        gender: user.gender || "",
        address: fullAddress || "",
        pincode: user.zip || "",
        mobileNumber: user.mobile_number || "",
        photo: user.has_image ? `${user.profileImage}` : null
      }));

      console.log("PHOTO!!!!!",formData.photo)
      console.log("PHOTO!!!!! user.profile_Image",user.profile_Image)
      console.log("PHOTO!!!!! user.has_image",user.has_image)

      setKycCompleted(true);
      setCurrentStep(3);
      return true; // so nextStep can detect success
    } else {
      setErrors({ otp: data.message || "Invalid OTP. Please try again." });
      return false;
    }
  } catch (error) {
    console.error("Error verifying OTP:", error);
    setErrors({ otp: "Something went wrong. Please try again." });
    return false;
  } finally {
    setIsProcessing(false);
  }
};


// const verifyOTP = async () => {
//   // if (!validateStep(2)) return;

//   setIsProcessing(true);

//   try {
//     const storedKYC = localStorage.getItem("eKYCDataForVerify");
//     const parsedKYC = storedKYC ? JSON.parse(storedKYC) : null;

//     const requestId = parsedKYC?.request_id;
//     const aadhaarUserId = parsedKYC?.aadhaar_user_id;

//     if (!requestId || !aadhaarUserId) {
//       setErrors({ otp: "Missing Aadhaar verification data. Please request OTP again." });
//       setIsProcessing(false);
//       return;
//     }

//     const response = await fetch(VERIFY_AADHAAR, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         request_id: requestId,
//         otp: formData.otp,
//         aadhaar_user_id: aadhaarUserId,
//       }),
//     });

//     const data = await response.json();
//     console.log("VERIFY_AADHAAR response:", data);

//     if (response.ok && data.success) {
//       // Use API data if available
//       setFormData((prev) => ({
//         ...prev,
//         name: data.name || prev.name,
//         fatherName: data.fatherName || prev.fatherName,
//         dateOfBirth: data.dateOfBirth || prev.dateOfBirth,
//         gender: data.gender || prev.gender,
//         address: data.address || prev.address,
//         pincode: data.pincode || prev.pincode,
//         photo: data.photo || prev.photo
//       }));
//       setKycCompleted(true);
//       setCurrentStep(3);
//     } else {
//       setErrors(data.message || "Invalid OTP. Please try again.");
//     }
//   } catch (error) {
//     console.error("Error verifying OTP:", error);
//     setErrors({ otp: "Something went wrong. Please try again." });
//   } finally {
//     setIsProcessing(false);
//   }
// };

  // const nextStep = () => {
  //   // if (currentStep === 0 && validateStep(currentStep)) {
  //   if (currentStep === 0) {
  //     setCurrentStep(1);
  //   } else if (currentStep === 1) {
  //     sendOTP();
  //     setCurrentStep(2);
  //   } else if (currentStep === 2) {
  //     verifyOTP();
  //     setCurrentStep(3);
  //   }
  //   else{
  //     alert("nahi chal raha")
  //   }
  // };

const nextStep = async () => {
  if (currentStep === 0) {
    setCurrentStep(1);
  } else if (currentStep === 1) {
    const otpSent = await sendOTP();
    if (otpSent) {
      setCurrentStep(2);
    }
  } else if (currentStep === 2) {
    const otpVerified = await verifyOTP();
    if (otpVerified) {
      setCurrentStep(3);
    }
  }
};

  const prevStep = () => {
    if (currentStep === 2 && otpSent) {
      // Don't go back if OTP is in progress
      return;
    }
    setCurrentStep(prev => Math.max(prev - 1, 0));
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const renderMobileVerification = () => (
    <div className="space-y-4 sm:space-y-6">
      <div className="text-center">
        <Phone className="mx-auto h-12 w-12 sm:h-16 sm:w-16 text-blue-500 mb-3 sm:mb-4" />
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">Aadhaar Verification is Pending...</h3>
        <p className="text-sm sm:text-base text-gray-600 px-2">
          Click <b>Continue</b> to begin eKYC process
        </p>
      </div>

      <div>
        {/* <label className="block text-sm font-medium text-gray-700 mb-2">
          Aadhaar Number <span className="text-red-500">*</span>
        </label> */}
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {/* <span className="text-gray-500 text-sm">+91</span> */}
          </div>
          {/* <input
            type="tel"
            value={formData.mobileNumber}
            onChange={(e) => handleInputChange('mobileNumber', e.target.value)}
            className={`w-full pl-12 pr-3 py-3 sm:py-4 border rounded-lg text-base sm:text-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
              errors.mobileNumber ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="Enter 12-digit Aadhaar number"
            maxLength="14"
          /> */}
        </div>
        {/* {errors.mobileNumber && <p className="text-red-500 text-sm mt-1">{errors.mobileNumber}</p>} */}
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4">
        <div className="flex">
          <AlertCircle className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 mr-2 mt-0.5 flex-shrink-0" />
          <div className="text-xs sm:text-sm text-blue-800">
            <p className="font-medium">Important:</p>
            <p className="mt-1">
              Please ensure you enter correct Aadhaar Card Number. 
              OTP will be sent to Aadhaar Linked number for verification.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAadhaarDetails = () => (
    <div className="space-y-4 sm:space-y-6">
      <div className="text-center">
        <Shield className="mx-auto h-12 w-12 sm:h-16 sm:w-16 text-green-500 mb-3 sm:mb-4" />
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">Aadhaar Verification</h3>
        <p className="text-sm sm:text-base text-gray-600 px-2">
          Enter your Aadhaar number and provide consent for eKYC
        </p>
      </div>
        <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Mobile Number <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.mobileNumber}
          onChange={(e) => handleInputChange('mobileNumber', e.target.value)}
          className={`w-full px-3 py-3 sm:py-4 border rounded-lg text-base sm:text-lg tracking-wider focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
            errors.mobileNumber ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="Enter 10-digit mobile number"
          maxLength="12"
        />
        {errors.mobileNumber && <p className="text-red-500 text-sm mt-1">{errors.mobileNumber}</p>}
      </div>
 <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Firm Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.firmName}
          onChange={(e) => handleInputChange('firmName', e.target.value)}
          className={`w-full px-3 py-3 sm:py-4 border rounded-lg text-base sm:text-lg tracking-wider focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
            errors.firmName ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="Enter Firm name"
          // maxLength="14"
        />
        {errors.firmName && <p className="text-red-500 text-sm mt-1">{errors.firmName}</p>}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Aadhaar Number <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.aadhaarNumber}
          onChange={(e) => handleInputChange('aadhaarNumber', e.target.value)}
          className={`w-full px-3 py-3 sm:py-4 border rounded-lg text-base sm:text-lg tracking-wider focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
            errors.aadhaarNumber ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="XXXX XXXX XXXX"
          maxLength="14"
        />
        {errors.aadhaarNumber && <p className="text-red-500 text-sm mt-1">{errors.aadhaarNumber}</p>}
      </div>

      {/* <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 sm:p-4">
        <div className="flex">
          <AlertCircle className="h-4 w-4 sm:h-5 sm:w-5 text-yellow-400 mr-2 mt-0.5 flex-shrink-0" />
          <div className="text-xs sm:text-sm text-yellow-800">
            <p className="font-medium">Data Security:</p>
            <p className="mt-1">
              Your Aadhaar number is encrypted and securely transmitted to UIDAI servers. 
              We do not store your Aadhaar number on our systems.
            </p>
          </div>
        </div>
      </div> */}

      {/* <div className="border border-gray-200 rounded-lg p-3 sm:p-4">
        <div className="flex items-start">
          <input
            type="checkbox"
            id="consent"
            checked={formData.consent}
            onChange={(e) => handleInputChange('consent', e.target.checked)}
            className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded flex-shrink-0"
          />
          <label htmlFor="consent" className="ml-3 text-xs sm:text-sm text-gray-700">
            <span className="font-medium">I hereby provide my consent</span> to perform eKYC using my Aadhaar number and understand that:
            <ul className="mt-2 list-disc list-inside space-y-1 text-xs text-gray-600">
              <li>My demographic and biometric information will be shared by UIDAI with the requesting entity</li>
              <li>This consent is valid for this transaction only</li>
              <li>I can withdraw this consent at any time</li>
              <li>My information will be used only for KYC purposes</li>
            </ul>
          </label>
        </div>
        {errors.consent && <p className="text-red-500 text-sm mt-1">{errors.consent}</p>}
      </div> */}
    </div>
  );

  const renderOTPVerification = () => (
    <div className="space-y-4 sm:space-y-6">
      <div className="text-center">
        <Key className="mx-auto h-12 w-12 sm:h-16 sm:w-16 text-purple-500 mb-3 sm:mb-4" />
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">OTP Verification</h3>
        <p className="text-sm sm:text-base text-gray-600 px-2">
          Enter the 6-digit OTP sent to your mobile number ending with ***{formData.mobileNumber.slice(-4)}
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Enter OTP <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.otp}
          onChange={(e) => handleInputChange('otp', e.target.value)}
          className={`w-full px-3 py-4 sm:py-5 border rounded-lg text-xl sm:text-2xl text-center tracking-widest focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
            errors.otp ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="XXXXXX"
          maxLength="6"
        />
        {errors.otp && <p className="text-red-500 text-sm mt-1">{errors.otp}</p>}
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <div className="flex items-center text-sm text-gray-600">
          <Clock className="h-4 w-4 mr-1" />
          {otpTimer > 0 ? (
            <span>Resend OTP in {formatTime(otpTimer)}</span>
          ) : (
            <span>OTP expired</span>
          )}
        </div>
        
        <button
          onClick={resendOTP}
          disabled={!canResendOtp || isProcessing}
          className={`text-sm font-medium self-start sm:self-auto ${
            canResendOtp && !isProcessing
              ? 'text-blue-600 hover:text-blue-800 cursor-pointer'
              : 'text-gray-400 cursor-not-allowed'
          }`}
        >
          {isProcessing ? (
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
              Sending...
            </div>
          ) : (
            <>
              <RefreshCcw className="h-4 w-4 inline mr-1" />
              Resend OTP
            </>
          )}
        </button>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-3 sm:p-4">
        <div className="flex">
          <Shield className="h-4 w-4 sm:h-5 sm:w-5 text-green-400 mr-2 mt-0.5 flex-shrink-0" />
          <div className="text-xs sm:text-sm text-green-800">
            <p className="font-medium">Secure Verification:</p>
            <p className="mt-1">
              OTP is generated by UIDAI and is valid for 10 minutes. 
              Do not share this OTP with anyone.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
const renderKYCComplete = () => (
  <div className="space-y-4 sm:space-y-6">
    <div className="text-center">
      <CheckCircle className="mx-auto h-12 w-12 sm:h-16 sm:w-16 text-green-500 mb-3 sm:mb-4" />
      <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">eKYC Completed Successfully!</h3>
      <p className="text-sm sm:text-base text-gray-600 px-2">
        Your identity has been verified successfully through Aadhaar eKYC
      </p>
    </div>

    <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 space-y-4">
      <h4 className="font-semibold text-gray-900 mb-4">Verified Information</h4>

      {/* Passport Photo */}
      {/* <div className="flex justify-center mb-4">
        <img
          src={formData.photo || "https://via.placeholder.com/150x200?text=No+Photo"}
          alt="Passport Photo"
          className="w-32 h-40 object-cover rounded-lg border border-gray-300 shadow-sm"
        />
      </div> */}

      <div className="grid grid-cols-1 gap-4 sm:gap-6">
        <div className="space-y-3">
          <div>
            <span className="text-sm font-medium text-gray-600">Name:</span>
            <p className="text-sm font-semibold break-words">{formData.name}</p>
          </div>

          <div>
            <span className="text-sm font-medium text-gray-600">Father's Name:</span>
            <p className="text-sm break-words">{formData.fatherName}</p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <span className="text-sm font-medium text-gray-600">Date of Birth:</span>
              <p className="text-sm">{formData.dateOfBirth}</p>
            </div>

            <div>
              <span className="text-sm font-medium text-gray-600">Gender:</span>
              <p className="text-sm">{formData.gender}</p>
            </div>
          </div>

          <div>
            <span className="text-sm font-medium text-gray-600">Address:</span>
            <p className="text-sm break-words">{formData.address}</p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <span className="text-sm font-medium text-gray-600">PIN Code:</span>
              <p className="text-sm">{formData.pincode}</p>
            </div>

            <div>
              <span className="text-sm font-medium text-gray-600">Mobile:</span>
              <p className="text-sm">+91 {formData.mobileNumber}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-green-50 border border-green-200 rounded-lg p-3 sm:p-4">
      <div className="flex">
        <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 text-green-400 mr-2 mt-0.5 flex-shrink-0" />
        <div className="text-xs sm:text-sm text-green-800">
          <p className="font-medium">Verification Complete</p>
          <p className="mt-1">
            Your eKYC process has been completed successfully. 
            This information has been verified against UIDAI records.
          </p>
        </div>
      </div>
    </div>

    <div className="text-center">
      <button
        onClick={() => {
          // localStorage.removeItem("eKYCDataForVerify");
          // localStorage.removeItem("eKYCData");
          navigate('/customer/dashboard');
          
        }}
        className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
      >
        Dashboard
      </button>
    </div>
  </div>
);


  const renderStepContent = () => {
    switch (currentStep) {
      case 0: return renderMobileVerification();
      case 1: return renderAadhaarDetails();
      case 2: return renderOTPVerification();
      case 3: return renderKYCComplete();
      default: return null;
    }
  };

  console.log("currentStep!!!!!!!!!!!!!!",currentStep)

  return (
    <div className="w-full min-h-screen bg-gray-50 sm:bg-white">
        <ToastContainer position="top-right" autoClose={5000} />
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-4xl mx-auto px-4 sm:px-6 py-4 sm:py-8 bg-white sm:shadow-lg sm:rounded-lg sm:my-4">
        <div className="mb-6 sm:mb-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-3 sm:mb-4">
              <Shield className="h-8 w-8 sm:h-10 sm:w-10 text-blue-600 mr-2 sm:mr-3" />
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Aadhaar eKYC</h1>
            </div>
            <p className="text-sm sm:text-base text-gray-600">Instant identity verification through Aadhaar</p>
          </div>
        </div>

        {/* Progress Steps - Mobile Optimized */}
        <div className="mb-6 sm:mb-8">
          <div className="flex flex-col space-y-3 sm:space-y-0 sm:flex-row sm:items-center sm:justify-between">
            {steps.map((step, index) => {
              const Icon = step.icon;
              const isActive = index === currentStep;
              const isCompleted = index < currentStep || (index === currentStep && kycCompleted);
              
              return (
                <div key={index} className="flex items-center">
                  <div className={`flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 ${
                    isCompleted ? 'bg-green-500 border-green-500 text-white' :
                    isActive ? 'bg-blue-500 border-blue-500 text-white' :
                    'bg-white border-gray-300 text-gray-400'
                  }`}>
                    <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                  </div>
                  <div className="ml-3 sm:ml-2 flex-1">
                    <span className={`text-xs sm:text-sm font-medium ${
                      isActive ? 'text-blue-600' : isCompleted ? 'text-green-600' : 'text-gray-400'
                    }`}>
                      {step.title}
                    </span>
                    {/* Mobile: Show step indicator line below */}
                    {index < steps.length - 1 && (
                      <div className={`w-0.5 h-6 ml-3.5 sm:ml-4 mt-2 sm:hidden ${
                        isCompleted ? 'bg-green-500' : 'bg-gray-200'
                      }`} />
                    )}
                  </div>
                  {/* Desktop: Show horizontal line */}
                  {index < steps.length - 1 && (
                    <div className={`hidden sm:block w-12 lg:w-16 h-0.5 mx-4 ${
                      isCompleted ? 'bg-green-500' : 'bg-gray-200'
                    }`} />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Step Content */}
        <div className="mb-6 sm:mb-8">
          {renderStepContent()}
        </div>

        {/* Navigation Buttons - Mobile Optimized */}
        {currentStep < 3 && (
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-0 sm:justify-between">
            <button
              onClick={prevStep}
              disabled={currentStep === 0 || (currentStep === 2 && otpSent)}
              className={`flex items-center justify-center px-4 py-3 rounded-lg transition-colors font-medium ${
                currentStep === 0 || (currentStep === 2 && otpSent)
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Previous
            </button>

            <button
              onClick={nextStep}
              disabled={isProcessing}
              className={`flex items-center justify-center px-6 py-3 rounded-lg transition-colors font-medium ${
                isProcessing
                  ? 'bg-gray-400 cursor-not-allowed text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
              }`}
            >
              {isProcessing ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  <span className="text-sm sm:text-base">
                    {currentStep === 1 ? 'Sending OTP...' : currentStep === 2 ? 'Verifying...' : 'Processing...'}
                  </span>
                </>
              ) : (
                <>
                  <span className="text-sm sm:text-base">
                    {currentStep === 1 ? 'Send OTP' : currentStep === 2 ? 'Verify OTP' : 'Continue'}
                  </span>
                  <ArrowRight className="w-4 h-4 ml-2" />
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AadhaarEKYCComponent;